'use strict'

const CONCATENATION_SEPARATOR_JSONFER = '.'
export const DIMENSION_ROLES = {
  DIMENSION: 'Dimension',
  MEASURE: 'Measure'
}
export const ELEMENT_TYPES = {
  STATISTIC: 'STATISTIC',
  DIMENSION: 'DIMENSION',
  COLUMN: 'COLUMN',
  MEASURE: 'MEASURE'
}

export default class ProccessJsonStatWrapper {
  /* Objetos para el dinamismo, aqui introducimos los parámetros y simplemente cargando desde un json-stat los introducirá en las letiables necesarias */
  /* No se usa el objeto de abajo directamente ya que al recorrer un objeto el orden es alfabetico no el que introduzcamos */
  /* SIEMPRE QUE NECESITEMOS QUE LAS DIMENSIONES SE RECORRAN EN ORDEN DEBEREMOS RECORRER ELEMENTS no la DIM */
  _instanceOf = ''
  _statData = {} // Objecto de JPlaka
  _orderColumns = [] // Columnas por el orden solicitadas
  _orderRows = [] // Filas por el orden solicitadas
  _orderFilters = [] // Filtros por el orden solicitado
  _rowsOptions = {} // Opciones de filas
  _columnsOptions = {} // Opciones de columnas
  _orderAsc = []
  _orderDesc = []

  JPLAKA_INSTANCE = 'JPlaka'
  MEASURE_KEY = '[Measures]'

  constructor (data = []) {
    this._statData = data.data
    this._instanceOf = data.type
  }

  _getDimensionOrder = (dimension) => {
    return this._orderAsc.indexOf(dimension) !== -1 ? 'asc' : this._orderDesc.indexOf(dimension) > -1 ? 'desc' : ''
  }
  _loadDimensionOptions = () => {
    this._columnsOptions = {}
    this._rowsOptions = {}
    let numberDims = this._statData.keys.length
    for (let pos = 0; pos < numberDims; pos++) {
      let dimension = this._statData.keys[pos]
      if (this._orderColumns.indexOf(dimension) !== -1) { // Esta en columnas
        this._columnsOptions[dimension] = this.getDimensionValues(dimension, this._getDimensionOrder(dimension))
      } else if (this._orderRows.indexOf(dimension) !== -1) { // Esta en filas
        this._rowsOptions[dimension] = this.getDimensionValues(dimension, this._getDimensionOrder(dimension))
      }
    }
  }
  _arr2num = (arr = []) => {
    if (this._instanceOf === this.JPLAKA_INSTANCE) {
      return this._statData.values[arr.join(CONCATENATION_SEPARATOR_JSONFER)]
    } else {
      return -1
    }
  }
  _cartesianProduct = (arr = []) => (
    arr.reduce((a, b) => (
      a.map((x) => (
        b.map((y) => (
          x.concat(y)
        ))
      )).reduce((a, b) => (a.concat(b)), [])
    ), [[]])
  )
  _calculateOptions = (values) => {
    return values.length ? this._cartesianProduct(values) : []
  }
  /* _cartesianProduct = (array) => { // array = array of array
    let i = []
    let j = []
    let l = []
    let m = []
    let a1 = []
    let o = []
    if (!array || array.length === 0) return array
    a1 = array.splice(0, 1)
    array = this._cartesianProduct(array)
    for (i = 0, l = a1[0].length; i < l; i++) {
      if (array && array.length) {
        for (j = 0, m = array.length; j < m; j++) {
          o.push([a1[0][i]].concat(array[j]))
        }
      } else {
        o.push([a1[0][i]])
      }
    }
    return o
  } */
  _getDimIndex = (value) => ((this._statData.dimension[value] || {}).index || [])

  getValueByOptions = (options = []) => {
    let elementArr = [new Array(this._statData.keys.length)]
    options.forEach(opt => {
      let parentPosition = this._statData.keys.indexOf(opt.parent)
      let idPosition = this._getDimIndex(opt.parent).map(index => index.id).indexOf(opt.id)
      if (parentPosition !== -1 && idPosition !== -1) {
        elementArr[parentPosition] = idPosition
      } else {
        console.error(`Not found element ${opt.parent} with value ${opt.id}`)
      }
    })
    return this._arr2num(elementArr)
  }
  setElements = ({ cols = [], rows = [], filters = [], asc = [], desc = [] } = {}) => {
    this._orderColumns = [...new Set(cols.map(e => e.type !== ELEMENT_TYPES.MEASURE ? e.idElement : this.MEASURE_KEY))]
    this._orderRows = [...new Set(rows.map(e => e.type !== ELEMENT_TYPES.MEASURE ? e.idElement : this.MEASURE_KEY))]
    this._orderFilters = [...new Set(filters.map(e => e.type !== ELEMENT_TYPES.MEASURE ? e.idElement : this.MEASURE_KEY))]
    this._orderAsc = [...new Set(asc.map(e => e.type !== ELEMENT_TYPES.MEASURE ? e.idElement : this.MEASURE_KEY))]
    this._orderDesc = [...new Set(desc.map(e => e.type !== ELEMENT_TYPES.MEASURE ? e.idElement : this.MEASURE_KEY))]
    this._loadDimensionOptions()
  }
  calculateNumberColsInTable = () => {
    let pos = 1
    let splitElements = 1
    for (let dim of this._rowsOptions) {
      let elements = dim.length
      pos *= elements
      splitElements *= elements
    }

    for (let dim of this._columnsOptions) {
      let elements = dim.length
      pos *= elements
    }
    return splitElements !== 0 ? pos / splitElements : 0
  }
  getRows = () => this._orderRows
  getColumns = () => this._orderColumns
  getDimensionValues = (dimension, order = '') => {
    let indexArr = this._getDimIndex(dimension).slice(0)
    // let typeData = this.getTypeData(dimension)
    if (order.length > 0) {
      /* this.sortBy(indexArr, {
        desc: order === 'desc',
        parser: (item) => {
          if (typeData === 'number') {
            return Number(item)
          } else if (typeData === 'date') {
            return new Date(item)
          } else {
            return item.toUpperCase()
          }
        }
      }) */
      console.error('Order not implemented yet')
    }
    return indexArr
  }
  getMeasuresValues = () => this.getDimensionValues(this.MEASURE_KEY)
  getDimensionsOptionsInRow = () => {
    let rowInOrder = []
    this._orderRows.forEach(o => rowInOrder.push(this._rowsOptions[o] || []))
    return this._calculateOptions(rowInOrder)
  }
  getDimensionsOptionsInColumns = () => {
    let colsInOrder = []
    this._colsOptions.forEach(o => colsInOrder.push(this._colsOptions[o] || []))
    return this._calculateOptions(colsInOrder)
  }
  getTypeData = (dimension) => (this._statData.dimension[dimension] || {}).type_data
  isEmpty = () => this._statData.keys.length === 0
  getValues = () => (this._statData || {}).values || {}
}
